export function initOptionsSlider() {
	const el = document.querySelector(".options.swiper");
	if (!el || typeof window.Swiper === "undefined") return;

	new window.Swiper(el, {
		loop: true,
		slidesPerView: "auto",
		speed: 250,
		pagination: {
			el: el.querySelector(".swiper-pagination"),
			clickable: true,
		},
		a11y: {
			slideRole: "article",
		},
		breakpoints: {
			0: {
				enabled: true,
				slidesPerView: 1,
			},
			768: {
				enabled: false,
			},
		},
	});
}
